export const EXPERIENCE_TYPES = {
  TEXT: "text",
  VOICE: "voice"
};

Object.freeze(EXPERIENCE_TYPES);

export const VIDEOS = {
  CONVERSATION: "conversation",
  DWELL: "dwell"
};

Object.freeze(VIDEOS);

export const FADE_DURATION = 150;
